// extracted by mini-css-extract-plugin
export default {"Rating":"styles_Rating__K4jlS","Review":"styles_Review__iVut-","Quotes":"styles_Quotes__qgh9K","Person":"styles_Person__qkrLf","Footer":"styles_Footer__EVx7G"};